import React, { useEffect,useMemo,useState } from "react";
import { Container,UncontrolledTooltip,Form, FormGroup, Label, Input, Button, Row, Col,  Card, CardBody,Table,Spinner } from "reactstrap";
import TableContainer from '../../../components/Common/TableContainer';

// Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";

import { Link } from "react-router-dom";
import * as Yup from "yup";
import { useFormik,Formik, Field, ErrorMessage } from "formik";
import Select from 'react-select';
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from "react-redux";
import {
  fetchRoles,
  fetchLoginDetails,
  fetchCategories,
  fetchUnits,
  fetchUnregisteredEmployees,
  createLoginUserRequest,
  resetPasswordRequest,
  toggleUserStatusRequest
} from "store/actions";
import {LandingPages} from "../../../common/data/constants"
import { toast } from "react-hot-toast";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import PasswordResetModal from './reset_password';
import CustomSelect from "components/Common/custom-select";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";
const LoginCreation = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete, canApprove } = useButtonAccess(accessRight);
  const dispatch = useDispatch();
  const { roles} = useSelector((state) => state.rolesReducer || {});
  const { loginDetails, unregisteredEmployees, loading, success, error } = useSelector((state) => state.LoginCreation || {});
  // const { unregisteredEmployees,unregisteredEmployeesLoading  } = useSelector((state) => state.LoginCreation || {});
  const { categories } = useSelector((state) => state.CategoryMaster || {});
  const { units } = useSelector((state) => state.UnitMaster || {});
  const [isEdit, setIsEdit] = useState(false);
  const [authDetails, setAuthDetails] = useState(null);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const toggleModal = (userId) => {
    setSelectedUserId(userId)
    setModalOpen(!modalOpen);
  };

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchRoles(unitId));
    dispatch(fetchLoginDetails(unitId));
    dispatch(fetchUnregisteredEmployees(unitId));
    dispatch(fetchCategories(unitId));
    dispatch(fetchUnits(unitId));
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchLoginDetails(authDetails?.unit_id));
    dispatch(fetchUnregisteredEmployees(authDetails?.unit_id));
  }, [authDetails,success,dispatch]);

  // const columns = useMemo(() => [
  //   {
  //     Header: "Action",
  //     Cell: (cellProps) => {
  //       const { status, EmpNo, EmpId } = cellProps.row.original;
  //       const isActive = status === 1; // Status 1 = Active
  //       const safeEmpNo = EmpNo.replace(/[^a-zA-Z0-9_-]/g, "_");
  //       return (
  //         <div className="d-flex gap-3">
  //           {/* Edit */}
  //           <Link
  //             to="#"
  //             className="text-success"
  //             onClick={() => handleEdit(cellProps.row.original)}
  //           >
  //             <i className="bx bxs-edit font-size-18" id={`edittooltip-${safeEmpNo}`} />
  //             <UncontrolledTooltip placement="top" target={`edittooltip-${safeEmpNo}`}>
  //               Edit
  //             </UncontrolledTooltip>
  //           </Link>

  //           {/* Status Toggle */}
  //           <Link
  //             to="#"
  //             style={{ color: isActive ? "green" : "red" }}
  //             onClick={() => handleToggleStatus(EmpId, isActive)}
  //           >
  //             <i
  //               className={`mdi ${
  //                 isActive ? "mdi-check-circle" : "mdi-close-circle"
  //               } font-size-18`}
  //               id={`status-tooltip-${safeEmpNo}`}
  //             />
  //             <UncontrolledTooltip placement="top" target={`status-tooltip-${safeEmpNo}`}>
  //               {isActive ? "Active" : "Inactive"}
  //             </UncontrolledTooltip>
  //           </Link>

  //           {/* Reset Password */}
  //           <Link to="#" className="text-danger" onClick={() => toggleModal(EmpId)}>
  //             <i className="mdi mdi-refresh font-size-18" id={`resettooltip-${safeEmpNo}`} />
  //             <UncontrolledTooltip placement="top" target={`resettooltip-${safeEmpNo}`}>
  //               Reset Password
  //             </UncontrolledTooltip>
  //           </Link>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     Header: "S.No",
  //     Cell: ({ row }) => loginDetails.length - row.index,
  //   },
  //   {
  //     Header: "Employee ID",
  //     accessor: "EmpNo",  
  //   },
  //   {
  //     Header: "Username",
  //     accessor: "FirstName",  
  //   },
  //   {
  //     Header: "Role",
  //     accessor: "UserRoleName",  
  //   },
  //   {
  //     Header: "Unit",
  //     accessor: "UnitName",
  //     Cell: ({ value }) => value ? value.replace(/,\s*$/, '') : "",
  //   },
  //   {
  //     Header: "Categories",
  //     accessor: "EmpCategory",
  //     Cell: ({ value }) => value ? value.replace(/,\s*$/, '') : "", 
  //   },
  //   {
  //     Header: "Email",
  //     accessor: "emailid",
  //   },
    
  // ], [loginDetails]);
   
  const columns = useMemo(() => {
    const cols = [
      {
        Header: "S.No",
        className: "serial-no",
        applyHeaderClass: true,
        Cell: ({ row }) => loginDetails.length - row.index,
      },
      {
        Header: "Employee ID",
        accessor: "empNo",
      },
      {
        Header: "Username",
        accessor: "firstName",
      },
      {
        Header: "Role",
        accessor: "userRoleName",
      },
      {
        Header: "Unit",
        accessor: "unitName",
        Cell: ({ value }) => value ? value.replace(/,\s*$/, "") : "",
      },
      {
        Header: "Categories",
        accessor: "empCategory",
        Cell: ({ value }) => value ? value.replace(/,\s*$/, "") : "",
      },
      // {
      //   Header: "Email",
      //   accessor: "emailid",
      // },
    ];

    // ⭐ Action column only if permission exists
    if (canEdit || canDelete) {
      cols.unshift({
        Header: "Action",
        Cell: (cellProps) => {
          const { status, EmpNo, EmpId } = cellProps.row.original;
          const isActive = status === 1;
          const safeEmpNo = EmpNo?.replace(/[^a-zA-Z0-9_-]/g, "_") || "emp";

          return (
            <div className="d-flex gap-3">

              {/* EDIT + RESET (canEdit) */}
              {canEdit && (
                <>
                  <Link
                    to="#"
                    className="text-success"
                    onClick={() => handleEdit(cellProps.row.original)}
                  >
                    <i className="bx bxs-edit font-size-18"
                      id={`edit-${safeEmpNo}`} />
                  </Link>

                  <Link
                    to="#"
                    className="text-warning"
                    onClick={() => toggleModal(EmpId)}
                  >
                    <i className="mdi mdi-refresh font-size-18"
                      id={`reset-${safeEmpNo}`} />
                  </Link>
                </>
              )}

              {/* STATUS TOGGLE (canDelete) */}
              {canDelete && (
                <Link
                  to="#"
                  style={{ color: isActive ? "green" : "red" }}
                  onClick={() => handleToggleStatus(EmpId, isActive)}
                >
                  <i
                    className={`mdi ${isActive ? "mdi-check-circle" : "mdi-close-circle"} font-size-18`}
                    id={`status-${safeEmpNo}`}
                  />
                </Link>
              )}

            </div>
          );
        },
      });
    }

    return cols;
  }, [loginDetails, canEdit, canDelete, canApprove]);


  const handleToggleStatus = (EmpId,isActive) => {
    Swal.fire({
      title: 'Are you sure?',
      text: `You are about to ${isActive ? 'deactivate' : 'activate'} this user.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
      reverseButtons: false,
      dangerMode: true,
    }).then((result) => {
      if (result.isConfirmed) {
          const formData = new FormData();
          formData.append("emp_id", EmpId);
          formData.append("status", isActive ? "1" : "0");
          formData.append("create_by", authDetails?.user_id);
          dispatch(toggleUserStatusRequest(formData));
      }    
    });
  };  
  
  const handleEdit = (row) => {
    console.log('Edit Employee > ', row);

    formik.setValues({
        employee: row?.empId || "", 
        employeeName: row?.firstName || "", 

        // Store role ID as string
        role: row?.userRoleId ? row.userRoleId.toString() : "",  

        mobileUser: row?.bActive || false, 
        userName: row?.loginname || "", 
        password: row?.loginPassword || "", 
        landingPage: row?.homePage ? row.homePage.toString() : "", 
        
        // Store only unit IDs as an array of strings
        unit: row?.unitId 
            ? row.unitId.split(",").filter(Boolean).map(unitId => unitId.trim()) 
            : [], 

        // Store only category IDs as an array of strings
        categoryVisibility: row?.empCategoryId 
            ? row.empCategoryId.split(",").filter(Boolean).map(catId => catId.trim()) 
            : [], 

        email: row?.emailid || "", 
        status: row?.status === 1, 
        Userid:row?.userid,
    });

    setIsEdit(true);
  };

   // Formik initialization
   const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
        employee: "",
        employeeName: "",
        role: "",
        mobileUser: false,
        userName: "",
        password: "",
        landingPage: "",
        unit: [], 
        categoryVisibility: [], 
        email: "",
        status: 1,
        Userid:0,
    },
    validationSchema: Yup.object({
        employee: Yup.string().required("Please select an employee"),
        role: Yup.string().required("Please select a role"),
        userName: Yup.string().required("Please enter a username"),
        password: Yup.string().required("Please enter a password"),
        landingPage: Yup.string().required("Please select a landing page"),
        unit: Yup.array().min(1, "Please select at least one unit").required("Unit is required"),
        categoryVisibility: Yup.array().min(1, "Please select at least one category visibility").required("Category visibility is required"),
        // email: Yup.string().email("Invalid email format").required("Please enter a valid email address"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {
        // Simulate form submit (API call)
        await new Promise((resolve) => setTimeout(resolve, 2000));

        const { unit_id, user_id } = authDetails;
        const formData = new FormData(); 
        
        formData.append("emp_id", values.employee); 
        formData.append("role_Id", values.role); 
        formData.append("user_name", values.userName); 
        formData.append("password", values.password); 
        formData.append("landingpage", values.landingPage);
        formData.append("Email", values.email); 
        formData.append("unit", values.unit.join(",")); 
        formData.append("categoryIds", values.categoryVisibility.join(","));
        formData.append("unit_id", unit_id);
        formData.append("created_by", user_id);
        formData.append("user_id", values.Userid);
  
        dispatch(createLoginUserRequest(formData));
        setIsEdit(false);
        formik.resetForm();
      } catch (error) {
        console.log('error > ',error)
      } finally {
        setSubmitting(false);
      }
    },
  });



  return (
    <React.Fragment>
    <div className="page-content">
      <Container fluid>
        {/* Render Breadcrumbs */}
        <Breadcrumbs title="Configuration" breadcrumbItem="Login Creation" />
  
        <Row>
          <Col lg="12">
          {(canCreate || canEdit) && (
          <Card>
            <CardBody>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="employee">
                        Employee <span className="text-danger">*</span>
                      </Label>
                      {isEdit ? (
                        <Input
                          type="text"
                          id="employee"
                          name="employee"
                          value={formik.values.employeeName || ""}
                          disabled // Make it readonly
                          className="form-control"
                        />
                      ) : (
                        <CustomSelect
                          id="employee"
                          name="employee"
                          options={unregisteredEmployees.map(emp => ({ value: emp.Empid, label: emp.emp_name }))} 
                          value={
                            unregisteredEmployees
                              .map(emp => ({ value: emp.Empid, label: emp.emp_name }))
                              .find(option => option.value === formik.values.employee) || null
                          }
                          onChange={(selected) => {
                            // Find the selected employee object
                            const selectedEmployee = unregisteredEmployees.find(emp => emp.Empid === selected.value);
                            
                            if (selectedEmployee) {
                              formik.setValues({
                                ...formik.values,
                                employee: selectedEmployee.Empid,
                                employeeName: selectedEmployee.emp_name,
                                userName: selectedEmployee.emp_code || "", // Set username
                                password: selectedEmployee.emp_code || "" // Set password
                              });
                            }
                          }}
                          onBlur={formik.handleBlur}
                          className={formik.touched.employee && formik.errors.employee ? "is-invalid" : ""}
                        />

                      )}

                      {formik.touched.employee && formik.errors.employee && (
                        <div className="text-danger">{formik.errors.employee}</div>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="role">
                        Role <span className="text-danger">*</span>
                      </Label>
                      <CustomSelect
                          id="role"
                          name="role"
                          options={roles.map(role => ({ value: role.role_id.toString(), label: role.role_name }))}
                          value={formik.values.role 
                              ? { value: formik.values.role, label: roles.find(role => role.role_id.toString() === formik.values.role)?.role_name || formik.values.role } 
                              : null}
                          onChange={(option) => formik.setFieldValue("role", option ? option.value : "")} // Store only string value
                          onBlur={formik.handleBlur}
                          isInvalid={formik.touched.role && !!formik.errors.role}
                      />


                      {formik.touched.role && formik.errors.role && (
                        <div className="text-danger">{formik.errors.role}</div>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="userName">
                        User Name <span className="text-danger">*</span>
                      </Label>
                      <Input
                        id="userName"
                        name="userName"
                        type="text"
                        value={formik.values.userName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={formik.touched.userName && formik.errors.userName}
                        disabled={!!formik.values.employee} // Disable if an employee is selected
                      />

                      {formik.touched.userName && formik.errors.userName && (
                        <div className="text-danger">{formik.errors.userName}</div>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="password">
                        Password <span className="text-danger">*</span>
                      </Label>
                      <Input
                        id="password"
                        name="password"
                        type="password"
                        value={formik.values.password}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={formik.touched.password && formik.errors.password}
                        placeholder="******"
                      />
                      {formik.touched.password && formik.errors.password && (
                        <div className="text-danger">{formik.errors.password}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="email">Email</Label>
                      <Input
                        id="email"
                        name="email"
                        type="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        invalid={formik.touched.email && formik.errors.email}
                      />
                      {formik.touched.email && formik.errors.email && (
                        <div className="text-danger">{formik.errors.email}</div>
                      )}
                    </FormGroup>
                  </Col> */}

                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="landingPage">
                        Landing Page <span className="text-danger">*</span>
                      </Label>
                      <CustomSelect
                        id="landingPage"
                        name="landingPage"
                        options={LandingPages.map(page => ({ value: page.id.toString(), label: page.label }))} 
                        value={LandingPages.find(page => page.id.toString() === formik.values.landingPage) || null}
                        onChange={(option) => formik.setFieldValue("landingPage", option ? option.value : "")}
                        onBlur={formik.handleBlur}
                        isInvalid={formik.touched.landingPage && !!formik.errors.landingPage}
                      />
                      {formik.touched.landingPage && formik.errors.landingPage && (
                        <div className="text-danger">{formik.errors.landingPage}</div>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="unit">
                        Unit <span className="text-danger">*</span>
                      </Label>
                      <CustomSelect
                          id="unit"
                          name="unit"
                          options={units.map(unit => ({ value: unit.unit_id.toString(), label: unit.short_name }))}
                          value={
                              units.filter(unit => formik.values.unit?.includes(unit.unit_id.toString()))
                                  .map(unit => ({ value: unit.unit_id.toString(), label: unit.short_name }))
                          }
                          onChange={(options) => formik.setFieldValue("unit", options ? options.map(option => option.value) : [])}
                          onBlur={formik.handleBlur}
                          isMulti
                          isInvalid={formik.touched.unit && !!formik.errors.unit}
                      />

                      {formik.touched.unit && formik.errors.unit && (
                        <div className="text-danger">{formik.errors.unit}</div>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="categoryVisibility">
                        Category Visibility <span className="text-danger">*</span>
                      </Label>
                      <CustomSelect
                          id="categoryVisibility"
                          name="categoryVisibility"
                          options={categories.map(cat => ({ value: cat.empCatgryid.toString(), label: cat.empCategory }))}
                          value={
                              categories.filter(cat => formik.values.categoryVisibility?.includes(cat.empCatgryid.toString()))
                                  .map(cat => ({ value: cat.empCatgryid.toString(), label: cat.empCategory }))
                          }
                          onChange={(val) => formik.setFieldValue('categoryVisibility', val ? val.map(v => v.value) : [])}
                          onBlur={formik.handleBlur}
                          isMulti
                          className={formik.touched.categoryVisibility && formik.errors.categoryVisibility ? 'is-invalid' : ''}
                      />

                      {formik.touched.categoryVisibility && formik.errors.categoryVisibility && (
                        <div className="text-danger">{formik.errors.categoryVisibility}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label className="mb-1">
                        <Input
                          id="mobileUser"
                          name="mobileUser"
                          type="checkbox"
                          checked={formik.values.mobileUser} 
                          onChange={formik.handleChange}  
                          className="me-2" 
                        />
                        Mobile User
                        </Label> 
                    </FormGroup>
                  </Col> */}

                  <Col md={3} sm={12} className="d-flex justify-content-end align-items-center">
                    <div className="d-flex flex-column flex-md-row w-100 justify-content-end ">
                    <Button 
                        type="submit" 
                        color="primary" 
                        className="mb-2 mb-md-0 btn button-save me-2" 
                        disabled={formik.isSubmitting}  // Disable button while submitting
                      ><i className="fas fa-save me-1" /> {isEdit ? "Update" : "Save"}
                        {/* {formik.isSubmitting ? (
                          <>
                            <Spinner size="sm" /> Processing...
                          </>
                        ) : (
                          isEdit ? "Update" : "Save"
                        )} */}
                      </Button>

                      <Button type="button" className="btn button-cancel mb-2 mb-md-0" onClick={() => {
                        formik.resetForm();
                        setIsEdit(false);
                      }}>
                       <i className="fas fa-sync me-1" /> Cancel
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
          )}
            <Card>
              <CardBody>
                <TableContainer
                  columns={columns}
                  data={loginDetails && loginDetails.length > 0 ? loginDetails : []}
                  isGlobalFilter={true}
                  customPageSize={10}
                  className="custom-header-css"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>

      <PasswordResetModal
          isOpen={modalOpen}
          toggle={toggleModal}
          userId={selectedUserId}
          authDetails={authDetails}
          dispatch={dispatch}
          resetPasswordRequest={resetPasswordRequest}
        />
    </div>
  </React.Fragment>
  

  );
};

export default LoginCreation;
